__webpack_require__.p = "https://assets.yurplan.com/yurplan-v1/dist/";